import type { Locale } from '~/common/@types'
import { parseLanguage } from '~/common/utils'

export const getMessages = async (locale: Locale): Promise<Record<string, string>> => {
  const language = parseLanguage(locale)
  const response = await fetch(`/intl/${language}.json`)
  if (!response.ok) {
    throw Error()
  }
  return await response.json()
}
